// extracted by mini-css-extract-plugin
export default {"host":"styles_host__CMbcI","logo":"styles_logo__CVJ2E","document":"styles_document__AIekS","footer":"styles_footer__JBSzd","footerLogo":"styles_footerLogo__1Jwqf"};